'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const table_types = require('../table.types.js');
const tableRow = require('../TableRow/table-row.js');

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Build the table header as a row
var createTableHeader = function createTableHeader(headerType, props) {
  return /*#__PURE__*/React__default.createElement(tableRow, _extends({
    type: headerType,
    rowIndex: table_types.CellTypes.HEADER ? 0 : -1
  }, props));
};

var TableHeader = function TableHeader(props) {
  var columnData = props.columnData;
  var columnGroups = [];
  var hasColGroupTitle = false; // Go through the data and build a header and potentially super-header rows

  columnData.forEach(function (column, i) {
    var hasColGroup = !!column.groupColumns;

    if (hasColGroup) {
      var columns = column.groupColumns;
      columnGroups.push( /*#__PURE__*/React__default.createElement("colgroup", {
        key: "col-".concat(i),
        span: columns.length
      }));
    }

    if (!hasColGroupTitle && column.groupTitle) {
      hasColGroupTitle = true;
    }
  });
  var tableHeader = createTableHeader(table_types.CellTypes.HEADER, props); // Determine if we need a superheader row

  var superHeader = null;

  if (hasColGroupTitle) {
    superHeader = createTableHeader(table_types.CellTypes.SUPER_HEADER, props);
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, columnGroups, /*#__PURE__*/React__default.createElement("thead", null, superHeader, tableHeader));
};

module.exports = TableHeader;
